module.exports = "mutation UpdateSlotItem($data:SlotItemInput!){updateSlotItem(data:$data){success}}"